import React, { useState, useEffect, forwardRef } from 'react'
import Reusabletable from './../EditableReportTable'
// import { uploadEmployeeMasterFile, getEmployees, updateEmployeesById, deleteEmployeesById, multiDeleteEmployeeMasterFile } from './../../../../redux/actions/Employee.action';
import { uploadUnitMasterFile, getUnits, updateUnitById, deleteUnitById, unitMasterSingleDataInput, multiDeleteClientUnitsFile } from './../../../../../services/global_redux/globale_actions/Unit.action';
import { useDispatch, useSelector } from 'react-redux';
import files from "./../../../../../assets/templates/global_template/unit_master.xlsx"
import List from '@mui/material/List';
import Multiselect from 'multiselect-react-dropdown';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Slide from '@mui/material/Slide';
import { useParams } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { getStates } from "./../../../../../services/global_redux/globale_actions/States.action";
import EditableTable from '../../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../../reUsableTemplates/ImportFileform/ImportFileform'
import { Modal } from 'react-bootstrap';
import into_icon from "../../../../../assets/global_assets/create_data_imgs/into_icon.png"
import {
    HiOutlineQrcode,
    HiOutlineHome,
    HiOutlineIdentification,
    HiOutlineOfficeBuilding,
    HiOutlineGlobeAlt,
    HiOutlineMap,
    HiOutlineLocationMarker,
    HiOutlineCalendar,
    HiOutlinePhone,
    HiOutlineUserCircle,
    HiOutlineUsers,
    HiOutlineUserGroup,
    HiOutlineTag,
    HiOutlineMail,
    HiOutlineUser,
    HiOutlineAnnotation,
    HiOutlineBriefcase,
    HiOutlineClock,
    HiOutlinePause,
    HiOutlineSun,
    HiOutlineClipboardList,
    HiOutlineDocumentReport,
    HiOutlineBadgeCheck,
    HiOutlineDocumentDuplicate,
    HiOutlineCheckCircle,
    HiOutlineClipboardCheck,
    HiOutlineTicket,
    HiOutlineCurrencyRupee,
    HiOutlinePencil,
    HiOutlineShieldCheck,
    HiOutlineViewGrid,
} from "react-icons/hi";
import "./UnitClients.css"
import Select, { components } from 'react-select';
import { getUserRole } from './../../../../../services/global_redux/globale_actions/Role.action';
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function Units({ setLoading, showSnackbar }) {
    const { id } = useParams();
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const [activeForm, setActiveForm] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [data, setData] = useState([]);
    const [openeditalert, setOpeneditalert] = useState(false);
    const [opendeletealert, setopendeletealert] = useState(false);
    const [deleteclientid, setdeleteclientid] = useState(null);
    const [openaddsingle, setOpenaddsingle] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [checkedItemCount, setCheckedItemCount] = useState(0);
    const [order, setorder] = useState('ASC');
    const [statedata, setstate] = useState([]);
    const tableName = "ClientTable";
    const [selectedOptions, setSelectedOptions] = useState([]);
    const dispatch = useDispatch();
    const { date } = useParams();
    const [checkCreate, setCheckCreate] = useState(false);
    const [checkEdit, setCheckEdit] = useState(false);
    const [checkDelete, setCheckDelete] = useState(false); 

    const initialClientUnitDataInput = {
        unit_id: "",
        unit_name: "",
        client_id: "",
        client_name: "",
        state: "",
        Location_City: "",
        Address: "",
        Headcount_Male: "",
        Headcount_Female: "",
        Headcount_Transgender: "",
        Unit_Start_Date: "",
        AuthorisedSignatory: null,
        Authorised_Seal: null,
        Telephone_No: "",
        Email_ID: "",
        branch_type: "",
        name_of_principal_employer: "",
        address_of_principal_employer: "",
        unit_nature_of_work: "",
        WorkingHours: "",
        BreakTime: "",
        WeeklyHoliday: "",
        Select_leave_codes: "",
        SnE_No: "",
        SnE_Validity: "",
        CLEARC: "",
        CLRARC_Validity: "",
        CLRALicense: "",
        CLRALicense_Validity: "",
        SalaryDate: "",
      };

    const excludedKeyToCreate = [
    "Headcount_Male",
    "Headcount_Female",
    "Headcount_Transgender"
    ];
      
    const fetchState = async () => {
        try {
            const response = await dispatch(getStates());
            setstate(response.data.states);
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    }


    const [formData, setFormData] = useState(initialClientUnitDataInput);


    const header = [
        { key: "unit_id", value: "Branch ID", input: "text" ,readOnly:true, Icon: HiOutlineQrcode},
        { key: "unit_name", value: "Branch Name", input: "text" ,readOnly:false, Icon: HiOutlineHome},
        { key: "client_id", value: "Organization ID", input: "text", readOnly:true, Icon: HiOutlineIdentification  },
        { key: "client_name", value: "Organization Name", input: "text" ,readOnly:true, Icon: HiOutlineOfficeBuilding},
        { key: "state", value: "State Name", input: "text", Icon: HiOutlineGlobeAlt },
        { key: "Location_City", value: "Location/City", input: "text", Icon: HiOutlineMap },
        { key: "Address", value: "Address", input: "text", Icon: HiOutlineLocationMarker },
        { key: "Unit_Start_Date", value: "Branch Start Date", input: "date", Icon: HiOutlineCalendar },
        { key: "Telephone_No", value: "Telephone No",input:"text", Icon: HiOutlinePhone },
        { key: "Headcount_Male", value: "Headcount Male", input: "number", Icon: HiOutlineUserCircle },
        { key: "Headcount_Female", value: "Headcount Female", input: "number", Icon: HiOutlineUsers },
        { key: "Headcount_Transgender", value: "Headcount Transgender", input: "number", Icon: HiOutlineUserGroup },
        // { key: "NatureOfWork", value: "Nature Of Work",input:"text" },
        { key: "branch_type", value: "Branch Type", input: "text", Icon: HiOutlineTag},
        { key: "Email_ID", value: "Email ID", input:"email", Icon: HiOutlineMail },
        { key: "name_of_principal_employer", value: "Name of the Principal Employer", input: "text", Icon: HiOutlineUser},
        { key: "address_of_principal_employer", value: "Address of the Principal Employer", input: "text", Icon: HiOutlineAnnotation},
        { key: "unit_nature_of_work", value: "Nature of Work", input: "text", Icon: HiOutlineBriefcase},
        { key: "WorkingHours", value: "Working Hours", input: "text", Icon: HiOutlineClock },
        { key: "BreakTime", value: "Break Time",input:"text", Icon: HiOutlinePause },
        { key: "WeeklyHoliday", value: "Weekly Holiday", input:"text", Icon: HiOutlineSun },
        { key: "Select_leave_codes", value: "Select Leave Codes", input:"text", Icon: HiOutlineClipboardList },
        { key: "SnE_No", value: "S&E No",input:"text", Icon: HiOutlineDocumentReport },
        { key: "SnE_Validity", value: "S&E Validity",input:"date", Icon: HiOutlineBadgeCheck },
        { key: "CLEARC", value: "CLRARC" ,input:"text", Icon: HiOutlineDocumentDuplicate},
        { key: "CLRARC_Validity", value: "CLRARC Validity" ,input:"date", Icon: HiOutlineCheckCircle},
        { key: "CLRALicense", value: "CLRA License" ,input:"text", Icon: HiOutlineClipboardCheck},
        { key: "CLRALicense_Validity", value: "CLRA License Validity" ,input:"date", Icon: HiOutlineTicket},
        { key: "SalaryDate", value: "Salary Date", input: "number", Icon: HiOutlineCurrencyRupee },
        { key: "AuthorisedSignatory", value: "Authorised Signatory",input:"file", Icon: HiOutlinePencil },
        { key: "Authorised_Seal", value: "Authorised Seal",input:"file", Icon: HiOutlineShieldCheck },

    ]
    const daysoptions = [
        { key: 'Sunday', value: '6' },
        { key: 'Monday', value: '0' },
        { key: 'Tuesday', value: '1' },
        { key: 'Wednesday', value: '2' },
        { key: 'Thursday', value: '3' },
        { key: 'Friday', value: '4' },
        { key: 'Saturday', value: '5' },
    ];

    const [actionChecked, setActionChecked] = useState("");

    const fetchdata = async () => {
        setLoading(true);
        try {
            const response = await dispatch(getUnits(id));
            console.log("response unit master", response);

            if (response.data) {
                setGetData(response.data);
                setLoading(false);
            } else {
                setGetData([]);
                setLoading(false);
            }
            console.log(response.data);
        } catch (err) {
            console.error("Failed to fetch clients:", err);
            setLoading(false);
        }
    }
    useEffect(() => {

        fetchdata();
        fetchState();
    }, [dispatch]);



    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    
    //             const response = await dispatch(uploadUnitMasterFile(file,id));
    //             console.log("upload employee master response", response);
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };


const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'unit_master_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadUnitMasterFile(file,id));
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            
            setActionChecked("create");
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.inserted_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};




    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteClientUnitsFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }
    const handleCloseeditalert = () => {
        setOpeneditalert(false);
    };

    const handledeleteClosealert = () => {
        setopendeletealert(false);
    };

    const handleSaveClick = async (e) => {
        const email = editedValues.Email_ID?.trim();
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

        if (email && !emailRegex.test(email)){
            showSnackbar("Enter a valid email address (e.g., user@example.com)","warning");
            return;
        }
        const workingHours = editedValues.WorkingHours?.trim();
        const workRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)\s?,\s?(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)$/i;
        const breakTime = editedValues.BreakTime?.trim();
        if (!breakTime) {
            showSnackbar("Break Time cannot be empty","warning");
            return;
        }
        else if (breakTime && !workRegex.test(breakTime)){
            showSnackbar("Break Time must be in format like 01:30 PM or 02:30 PM","warning");
            return;
        }
        if (!workingHours) {
            showSnackbar("Working Hours cannot be empty","warning");
            return;
        }
        else if (workingHours && !workRegex.test(workingHours)){
            showSnackbar("Working Hours must be in format like 06:30 AM or 9:30 PM","warning");
            return;
        }
        
        const telNo = editedValues.Telephone_No;
        const telRegex = /^[0-9-]+$/;

        if (telNo && !telRegex.test(telNo)){
            showSnackbar("Telephone number can contain only digits, spaces, parentheses (), and hyphens (-). are allowed.","warning");
            return;
        }

        let salaryDate;
        if(typeof editedValues.SalaryDate === String){
            salaryDate = editedValues.SalaryDate?.trim();
        }
        else{
            salaryDate = editedValues.SalaryDate;
        }
        const salaryRegex = /^(?:[1-9]|[12][0-9]|3[01])$/;
        if (!salaryDate) {
            showSnackbar("Salary Date cannot be empty","warning");
            return;
        }
        else if (salaryDate && !salaryRegex.test(salaryDate)){
            showSnackbar("Salary date must be a number between 1 and 31 (e.g., 1, 2, 3). Leading zeros (01, 02) and values above 31 are not allowed.", "warning");            return;
            return;
        }

        const seNo = editedValues.SnE_No?.trim();
        const CLEARC = editedValues.CLEARC?.trim();
        const CLRALicense = editedValues.CLRALicense?.trim();
        const seNoRegex = /^[A-Za-z0-9\/-]+$/;
        
        if (CLEARC && !seNoRegex.test(CLEARC)){
            showSnackbar("CLRARC License can contain only letters, numbers, slashes (/), and hyphens (-).","warning");
            return;
        }
        if (CLRALicense && !seNoRegex.test(CLRALicense)){
            showSnackbar("CLRA License can contain only letters, numbers, slashes (/), and hyphens (-).","warning");
            return;
        }
        if (seNo && !seNoRegex.test(seNo)){
            showSnackbar("S & E number can contain only letters, numbers, slashes (/), and hyphens (-).","warning");
            return;
        }
        const weeklyHoliday = editedValues.WeeklyHoliday;
        if (!weeklyHoliday) {
            showSnackbar("Weekly Holiday cannot be empty","warning");
            return;
        }
        setLoading(true);
        try {
            const response = await dispatch(updateUnitById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handleDeleteClick = async () => {
        setLoading(true);
        setopendeletealert(false);
        try {
            const response = await dispatch(deleteUnitById(deleteclientid));
            if (response.success) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setopendeletealert(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
                setopendeletealert(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
        setEditableRow(null);

    };

    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteUnitById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, valueObj]) => {
                formDataToSend.append(key, valueObj.value);
        });
        try {
            const response = await dispatch(unitMasterSingleDataInput(formData));
            if (response && response.success) {
                setLoading(false);
                showSnackbar('Branch added successfully!', 'success');
                addsinglehandleClose();
                setFormData(initialClientUnitDataInput);
                fetchdata();
                setActionChecked("create");
            } else {
                setLoading(false);
                showSnackbar(`Failed to add Branch: ${response.message || 'Unknown error'}`, 'error');
            }
        } catch (error) {                
            setLoading(false);
            showSnackbar(`Failed to add Branch: ${error.message}`, 'error');
        }
    };
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        const trimmedValue = value.replace(/^\s+/, "");
        setFormData((prev) => ({
            ...prev,
            [name]:  files ? files[0] : trimmedValue
          }));
      };
      const handleKeyDown = (e) => {
        if (e.key === " " && e.target.value.length === 0) {
          e.preventDefault();
        }
      };

    const addsinglehandleClickOpen = () => {
        setOpenaddsingle(true);
    };
    const addsinglehandleClose = () => {
        setOpenaddsingle(false);
        setIsFormOpen(false);
        setActiveForm(null);
    };

    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
                const rawPermissions = response?.data?.permissions;
                const parsedPermissions = typeof rawPermissions === "string"
                    ? JSON.parse(rawPermissions)
                    : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
                parsedPermissions.forEach((item) => {
                  if (item.section == "Configuration" && item.module == "Org Details") {
                        setCheckCreate(item.action.create);
                        setCheckEdit(item.action.edit);
                        setCheckDelete(item.action.delete);
                    }
                })
    
        } catch (err) {
          console.error("Failed to fetch states:", err);
        }

    };
    useEffect(() => {
      getUserPermission();
    }, [dispatch]);
    
    const MultiValueContainer = ({ getValue }) => {
        const selected = getValue().map((v) => v.label).join(", ");
        return <div style={{ color: "black", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{selected}</div>;
      };
    return (
        <div className='container-fluid'>

            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Unit Master'}
                filestemp={files}
                setLoading={setLoading}
                showSnackbar={showSnackbar}
                date={date}
                handleFormToggleSingleDataEntry ={handleFormToggleSingleDataEntry}
                isFormOpen = {isFormOpen}

            /> */}
        {checkCreate &&
            <ImportFileform
            setFiledata ={setFile}
            title={'Branch Details'}
            filestemp={files}
            handleFileUpload={handleFileUpload}
            File={file}
    
            />
        }
        <EditableTable
        
        header={header}
        MainIcon={HiOutlineViewGrid}
        title={'Branch Details'}
        data={getData}
        setEditableRow={setEditableRow}
        setEditedValues={setEditedValues}
        handledeleteClickOpenalert={handledeleteClickOpenalert}
        editableRow={editableRow}
        setLoading={setLoading}
        editedValues={editedValues}
        getEditPermission = {checkEdit}
        getDeletePermission = {checkDelete}
        date={date}
        submitdelete={submitdelete}
        handleSaveClick={handleSaveClick}
        showSnackbar={showSnackbar}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp={
            <>
            
            {checkCreate &&
                <button
                onClick={addsinglehandleClickOpen}
                >Branch Master</button>
            }
            </>
        }
        />
        <Dialog
                open={openeditalert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to edit this Unit? Any unsaved changes might be lost.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseeditalert}>No</Button>
                    <Button onClick={handleSaveClick}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={opendeletealert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to delete this Unit? This action cannot be undone.

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handledeleteClosealert}>No</Button>
                    <Button onClick={handleDeleteClick}>Yes</Button>
                </DialogActions>
            </Dialog>

            {/* <Dialog
                fullScreen
                open={openaddsingle}
                onClose={addsinglehandleClose}
                TransitionComponent={Transition}
                className='mt-5'
            >
                <AppBar className='client-add-single-header' sx={{ position: 'relative' }}>
                    <Toolbar >
                        <Typography sx={{ ml: 1, flex: 1 }} variant="h6" component="div">
                            Add Single Unit
                        </Typography>
                        <IconButton
                            edge="end"
                            color="inherit float-end"
                            onClick={addsinglehandleClose}
                            aria-label="close"
                        >
                            <CloseIcon className='text-white' />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <List>
    <div className="card mx-2">
        <div className="card-body">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="col-md-12">
                    <div className="row">
                        {Object.keys(formData).map((key) => (
                            <div className="col-md-3 mb-3" key={key}>
                                <label htmlFor={key}>
                                    <b>
                                        {key
                                            .replace(/_/g, ' ')
                                            .replace(/([a-z])([A-Z])/g, '$1 $2')
                                            .replace(/^./, (str) => str.toUpperCase())}
                                        <span className="text-danger">*</span>
                                    </b>
                                </label>

                                {key === "state" ? (
                                    <select
                                        className="form-control mt-1"
                                        id={key}
                                        name={key}
                                        value={formData[key].value}
                                        onChange={handleChange}
                                        required
                                    >
                                        {statedata ? (
                                            statedata.map((item) => (
                                                <option key={item.state_name} value={item.state_name}>
                                                    {item.state_name}
                                                </option>
                                            ))
                                        ) : (
                                            <option value="">No states available</option>
                                        )}
                                    </select>
                                ) : key === "WeeklyHoliday" ? (
                                    <Multiselect
                                        options={daysoptions}
                                        displayValue="key"
                                        onSelect={handleSelect}
                                        onRemove={handleSelect}
                                        selectedValues={selectedOptions}
                                        placeholder="Select options"
                                        id="multiselect"
                                    />
                                ) : formData[key].type === "file" ? (
                                    <input
                                        type={formData[key].type}
                                        className="form-control mt-1"
                                        id={key}
                                        name={key}
                                        onChange={handleChange}
                                        accept="image/*"
                                        required
                                    />
                                ) : (
                                    <input
                                        type={formData[key].type}
                                        className="form-control mt-1"
                                        id={key}
                                        name={key}
                                        placeholder=""
                                        value={formData[key].value}
                                        onChange={handleChange}
                                        required
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-md-12 pe-3 mb-5 pb-2">
                    <div className="row float-end">
                        <button className='btn btn-md btn-success me-3' type='submit'><b>Submit</b></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</List>
            </Dialog> */}
    <Modal 
      show={openaddsingle} 
      onHide={addsinglehandleClose} 
      centered 
      dialogClassName="custom-modal-dialog"
      backdrop="static"
      keyboard={false}
      style={{ zIndex: "9999" }}
      className='bg-transparent'
    >
    <div className="row d-flex justify-content-center align-items-center w-100 bg-transparent " style={{ marginTop:"10px" }}>
      <div className="bg-white createUnitTableMainContainer text-white " style={{ minWidth: "90vw",height:"90vh" ,padding:"5px",borderRadius:"10px",overflow:"auto",marginLeft:"20px"}}>
      <div className="row rounded p-0 m-0">
          <div className="col-md-12">
          <div className="row">
            <div className="close-btn-div">
                <button type="button" className=" float-end bg-light  " onClick={addsinglehandleClose} aria-label="Close"><img src={into_icon} alt="" /></button>
            </div>
            </div>
            <div className="row px-3">
                <div className="card-body-changes">
                    <form onSubmit={handleSubmit}>
                        <div className="col-md-12">
                            <div className="row">
                            {header.map((item) => (
                                !excludedKeyToCreate.includes(item.key) && (
                                <div className="col-md-3 mb-3" key={item.key}>
                                <label htmlFor={item.key}>
                                    <b>
                                    {item.value}
                                    <span className="text-danger">*</span>
                                    </b>
                                </label>

                                {/* File input */}
                                {item.input === "file" ? (
                                    <input
                                    type="file"
                                    className="form-control mt-1"
                                    id={item.key}
                                    name={item.key}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    accept={item.key === "Total_holidays" ? ".xls,.xlsx" : "image/*"}
                                    required
                                    />

                                // Dropdown for State
                                ) : item.key === "state_name" ? (
                                    <select
                                    className="form-control mt-1"
                                    id={item.key}
                                    name={item.key}
                                    value={formData[item.key] || ""}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    required
                                    >
                                    <option value="">--Select--</option>
                                    {statedata ? (
                                        statedata.map((item) => (
                                            <option key={item.state_name} value={item.state_name}>
                                                {item.state_name}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">No states available</option>
                                    )}
                                    </select>

                                ) : item.key === "WeeklyHoliday" ? (
                                    <Select
                                        options={daysoptions.map(d => ({ value: d.value, label: d.key }))}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        isSearchable={true}
                                        components={{
                                            MultiValue: () => null, // hide pills
                                            ValueContainer: (props) => (
                                            <components.ValueContainer {...props}>
                                                <MultiValueContainer getValue={props.getValue} />
                                            </components.ValueContainer>
                                            ),
                                        }}
                                        styles={{
                                            control: (provided) => ({
                                            ...provided,
                                            minHeight: "35px",
                                            height: "35px",
                                            fontSize: "14px",
                                            }),
                                            menu: (provided) => ({
                                            ...provided,
                                            maxHeight: "100px",
                                            overflow: "auto",
                                            }),
                                            option: (provided, state) => ({
                                            ...provided,
                                            color: "black",
                                            backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                            cursor: "pointer",
                                            }),
                                        }}
                                        onChange={(selected) => {
                                            const values = selected.map((s) => s.value);
                                            setFormData({
                                            ...formData,
                                            WeeklyHoliday: values.join(","),
                                            });
                                        }}
                                        
                                        
                                        value={daysoptions
                                            .map(d => ({ value: d.value, label: d.key }))
                                            .filter(opt =>
                                            formData.WeeklyHoliday
                                                ?.split(",")
                                                .map(v => v.trim())
                                                .includes(opt.value)
                                            )}
                                        
                                        placeholder="Select options"
                                        />
                                ) : (
                                    <input
                                    type={item.input}
                                    className="form-control mt-1"
                                    id={item.key}
                                    name={item.key}
                                    value={formData[item.key] || ""}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    required
                                    {...(item.input === "number" ? { min: 0 } : {})}
                                    />
                                )}
                                </div>
                            )))}
                            </div>
                        </div>

                        <div className="col-md-12 pe-3 mb-5 pb-2">
                            <div className="row float-end">
                            <button className="btn btn-md btn-success me-3" type="submit">
                                <b>Submit</b>
                            </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
          </div>
          </div>
        </div>
        </div>
        <div className="color-dark">
        {/* fffffzcdcvvv */}
        </div>
    </Modal>


        </div>
    )
}

export default Units





















